export function textToSnake(input: string): string {
  return input
    .replace(/[']/g, "")
    .replace(/\W+/g, " ")
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join("_");
}
